export default (params) => ({
  trigger: {
    name: 'store_stock_overlay.reserve_item_in_a_store',
    params: params,
  },
  config: {
    schema: {
      store_id: {
        type: 'integer',
      },
      store_name: {
        type: 'string',
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'generic_store_stock_overlay',
          'specific_store_stock_overlay',
        ],
      },
    },
    event: {
      name: 'reserve_item',
    },
  },
});
